module.exports = __webpack_public_path__ + "img/left_angle.61ba6214.jpg";